(ns minorodata.components.analytics-models.sidebar
  (:require [react :as react]
            ["lucide-react" :refer [Plus]]
            [minorodata.app.handlers :refer [dispatch]]
            [minorodata.components.analytics-models.run-status :refer [run-status-pill]]
            [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]
            [ui.button :as ui.button]
            [ui.date-time :refer [date-tooltip]]
            [ui.typography :as typography]
            [ui.utils :refer [clsx]]))


(defn- editor-name
  "Display name for an `updated-by` ref — handles an already-expanded user map,
   a `{:db/id n}` ref, or a raw user-id string."
  [updated-by]
  (let [user (cond
               (:searchable-user/username updated-by) updated-by
               (and (map? updated-by) (:db/id updated-by))
               @(re-posh/subscribe [:searchable-user/pull (:db/id updated-by)])
               (string? updated-by)
               @(re-posh/subscribe [:searchable-user/pull [:searchable-user/id updated-by]]))]
    (or (:searchable-user/username user) (:searchable-user/email user))))


(defn instance-row [{:keys [instance active-id]}]
  (let [{:analytics-model/keys [model-id name updated-at updated-by]} instance
        id         model-id
        active?    (= active-id id)
        editor     (editor-name updated-by)
        run-status @(re-frame/subscribe [:analytics-models.subs/last-run-status id])]
    [:button
     (cond-> {:type     "button"
              :class    (clsx "w-full min-w-0 text-left px-4 py-2 hover:bg-kleene-background-secondary"
                              (when active? "bg-kleene-background-secondary font-medium"))
              :data-cy  (str "analytics-model-instance-" id)
              :on-click #(dispatch [:app.events/navigate
                                    :analytics-model-instance-details
                                    {:instance-id id}])}
       active? (assoc :data-selected true))
     [:div {:class "flex items-center justify-between gap-2"}
      [:div {:class "truncate text-sm"} (or name "(unnamed)")]
      [:div {:class "shrink-0"} [run-status-pill run-status]]]
     (when updated-at
       [:div {:class "truncate text-xs font-normal text-kleene-text/50 mt-0.5"}
        "Updated " [date-tooltip {:date updated-at}]
        (when editor (str " by " editor))])]))


(defn group-block [{:keys [group active-id]}]
  (let [{:keys [display-name version items]} group]
    [:div {:class "border-b last:border-b-0"}
     [:div {:class "flex justify-between items-center px-4 py-2 text-xs text-kleene-text/60 bg-kleene-background-secondary/50"}
      [:span {:class "font-semibold uppercase"} display-name]
      [:span version]]
     (for [instance items]
       ^{:key (:analytics-model/model-id instance)}
       [instance-row {:instance instance :active-id active-id}])]))


(defn sidebar' [{:keys [route-params instance-groups loading?]}]
  (let [ref       (react/useRef nil)
        active-id (:instance-id route-params)]
    [:div {:class "flex flex-col overflow-hidden"}
     [:header {:class "shrink-0 border-b px-5 py-4 flex flex-row justify-between items-center bg-kleene-background"}
      [typography/h2 "Analytics models"]
      [ui.button/button
       {:variant  :secondary
        :size     :icon-md
        :icon     Plus
        :data-cy  "add-analytics-model-instance-btn"
        :on-click #(dispatch [:app.events/navigate :analytics-models])}]]
     [:div {:ref ref :class "flex-1 overflow-auto"}
      (cond
        loading?
        [:div {:class "py-8 text-center text-kleene-text/60"} "Loading..."]

        (empty? instance-groups)
        [:div {:class "py-8 text-center text-kleene-text/60"}
         "No analytics model instances yet"]

        :else
        (for [group instance-groups]
          ^{:key (:project-name group)}
          [group-block {:group group :active-id active-id}]))]]))

(defn sidebar []
  (let [instance-groups @(re-frame/subscribe [:analytics-models.subs/models-grouped])
        {:app-route/keys [params]} @(re-posh/subscribe [:app-route/pull])
        loading? (or @(re-posh/subscribe [:mold-http/loading? :analytics-models.api/fetch-models])
                     @(re-posh/subscribe [:mold-http/loading? :analytics-models.api/fetch-model-registry]))]
    [:f> sidebar' {:instance-groups instance-groups
                   :route-params    params
                   :loading?        loading?}]))
